import React, { useEffect } from "react";
import { useStateAuthValue } from "./context/AuthState";
import { checkAuth } from "./services/authService";
import AppRouter from "./router/AppRouter";

const App = () => {
  const [{ userToken }] = useStateAuthValue();

  useEffect(() => {
    if (userToken) checkAuth(userToken);
  }, [userToken]);

  return <AppRouter />;
};

export default App;
